const image = {
  displayField: null,
  name: 'Image',
  description: '',
  fields: [
    {
      id: 'image',
      name: 'Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    }
  ],
  sys: { id: 'image', version: 8, updatedAt: '2023-02-10T22:52:03.284Z' }
};
export default image;